import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../../../../Shared/AssociateNavbar/Navbar";
import ReusableTable from "../../../../Layout/ReusableTable";
import baseURL from "../../../../Apiurs/Apiurls";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import InvoicePDF from "../../../Admin/Sample/SamplePDF";
import "../../../../Layout/Collapse/Collapse.css"
import AddProduct from "../../../Admin/Lead/ViewLeads/AddProduct";
import { 
  FiArrowLeft, 
  FiPlus, 
  FiFileText, 
  FiEye,
  FiDownload, 
  FiSend,
  FiDollarSign,
  FiPercent,
  FiShoppingCart,
  FiUser,
  FiMail,FiEdit,FiSave,FiX,
  FiPhone,
  FiGlobe,FiTrash2
} from "react-icons/fi";
import "../../../Admin/Lead/ViewLeads/ViewLead.css";

const ViewLead = () => {
  const { id } = useParams();
  const location = useLocation();
  const leadInfo = location.state?.lead || {};
  console.log("leadinfo",leadInfo);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false); 
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const OpenAddModal = () => setShowModal(true);
  const [quantities, setQuantities] = useState([]);
  const [quotationStatus, setQuotationStatus] = useState(""); 

  const [error, setError] = useState(null);
  const [termsConditions, setTermsConditions] = useState('');
  const [originalTerms, setOriginalTerms] = useState('');
  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState('');




useEffect(() => {
  setQuantities(products.map((item) => item.quantity));
}, [products]);

const handleQuantityChange = async (index, value) => {
  const qty = value === "" ? 1 : Math.max(1, parseInt(value, 10));

  // ✅ Update products state so table re-renders
  const updatedProducts = [...products];
  updatedProducts[index] = { ...updatedProducts[index], quantity: qty };
  setProducts(updatedProducts);

  // ✅ Update in DB via API
  try {
    await axios.post(`${baseURL}/api/update-quantity`, {
      product_id: updatedProducts[index].id, // ensure "id" is present in fetched data
      quantity: qty,
    });
    console.log("Quantity updated in DB successfully");
  } catch (err) {
    console.error("Error updating quantity in DB:", err);
    alert("Failed to update quantity in database.");
  }
};



// Also update the fetch function to ensure it gets the latest status
const fetchLeadQuotationStatus = async () => {
  try {
    const res = await fetch(`${baseURL}/api/lead-quotation-status/${id}`);
    const data = await res.json();
    if (res.ok) {
      setQuotationStatus(data.quotation_status || "");
    }
  } catch (err) {
    console.error("Error fetching quotation status:", err);
  }
};

useEffect(() => {
  fetchLeadQuotationStatus();
}, [id]);



  // totals
  const [subtotal, setSubtotal] = useState(0);
  const [totalGST, setTotalGST] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
 
 const fetchEmailProducts = async () => {
  try {
    const res = await axios.get(`${baseURL}/api/all-email-products/${id}`);
    const data = res.data.map((row) => ({
      id: row.id,
      ...row,
      gstrate: row.gstrate ?? 5,
      listprice: row.listprice ?? 200,
      quantity: row.quantity ?? 1,
    }));
    console.log("Fetched products:", data); // 👀 debug
    setProducts(data);  // replace completely
  } catch (err) {
    console.error("Error fetching email products:", err);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
    fetchEmailProducts();
  }, [id]);

const handleSaveProduct = async (formData) => {
  try {
    const payload = { ...formData, lead_id: id };
    await axios.post(`${baseURL}/api/add-lead-product`, payload);

    alert("Product added successfully!");
    setShowModal(false);
    await fetchEmailProducts();   // ✅ force re-fetch
  } catch (err) {
    console.error("Error adding product:", err);
    alert("Failed to add product.");
  }
};

const handleDeleteProduct = async (productId) => {
  if (!window.confirm("Are you sure you want to delete this product?")) return;

  try {
    await axios.delete(`${baseURL}/api/delete-lead-product/${productId}`);
    alert("Product deleted successfully!");
    await fetchEmailProducts();  // ✅ force re-fetch
  } catch (err) {
    console.error("Error deleting product:", err);
    alert("Failed to delete product.");
  }
};



  // calculate totals whenever products change
  useEffect(() => {
    if (products.length > 0) {
      let sub = 0;
      let gstAmount = 0;

      products.forEach((p) => {
        const qty = p.quantity || 0;
        const price = p.listprice || 0;
        const gstRate = parseFloat(p.gstrate) || 0;

        const itemTotal = qty * price;
        const itemGST = (itemTotal * gstRate) / 100;

        sub += itemTotal;
        gstAmount += itemGST;
      });

      setSubtotal(sub);
      setTotalGST(gstAmount);
      setGrandTotal(sub + gstAmount);
    }
  }, [products]);


  // columns for the table
  const columns = [
   {
  key: "product",
  title: "Product",
  render: (row) => (
    <>
      <div><strong>{row.maincategory_name}</strong></div>
      <div className="adminviewproducts-viewlead-text-muted">{row.subcategory_name}</div>
      <div>{row.product_name} - {row.batch}</div>
      <div className="adminviewproducts-viewlead-text-muted">Size: {row.size}</div>
    </>
  )
},
    { key: "hsncode", title: "HSN Code", render: (row) => row.hsncode || "N/A" },
    { 
      key: "gstrate", 
      title: "GST (%)", 
      render: (row) => <span className="adminviewproducts-viewlead-badge adminviewproducts-viewlead-bg-light adminviewproducts-viewlead-text-dark">{row.gstrate}%</span>
    },
    { 
      key: "listprice", 
      title: "Price", 
      render: (row) => `₹${parseFloat(row.listprice || 0).toFixed(2)}` 
    },
   {
  key: "quantity",
  title: "Qty",
  render: (row, index) => (
    <input
      type="number"
      className="form-control"
      min={1}
      value={row.quantity}
      onChange={(e) => handleQuantityChange(index, e.target.value)}
      style={{ width: "80px" }}
    />
  )
},
    {
      key: "total",
      title: "Total",
      render: (row) => `₹${((row.quantity || 0) * (row.listprice || 0)).toFixed(2)}`
    },
    {
    key: "actions",
    title: "Actions",
    render: (row) => (
      <button
        className="btn btn-sm btn-danger"
        onClick={() => handleDeleteProduct(row.id)}
      >
        <FiTrash2 />
      </button>
    )
  }
  ];

 useEffect(() => {
    const fetchTermsConditions = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${baseURL}/api/leads/${id}/terms-conditions`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch terms and conditions');
        }
        
        const data = await response.json();
        
        if (data.success) {
          setTermsConditions(data.data.terms_conditions);
        } else {
          setError(data.message);
        }
      } catch (err) {
        console.error('Error fetching terms conditions:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTermsConditions();
    }
  }, [id]);







  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="adminviewproducts-viewlead-container-fluid adminviewproducts-viewlead-py-2 px-5">
          
          {/* Header Section */}
{/* Header Section */}
<div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center adminviewproducts-viewlead-justify-content-between">
  {/* Left Side: Profile + Name + Email + Phone */}
  <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
    {/* Profile Circle */}
    <div className="adminviewproducts-viewlead-avatar-circle adminviewproducts-viewlead-bg-primary adminviewproducts-viewlead-text-white">
      {leadInfo.lead_name ? leadInfo.lead_name.charAt(0).toUpperCase() : "L"}
    </div>

    {/* Name + Email + Phone beside profile */}
    <div
      className="adminviewproducts-viewlead-ms-3 adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
      style={{ gap: "20px" }}
    >
      {/* Name */}
      <h5 className="lead-name adminviewproducts-viewlead-mb-0 adminviewproducts-viewlead-me-4">
        {leadInfo.lead_name || "N/A"}
      </h5>

      {/* Email + Phone in one div */}
      <div
        className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
        style={{ gap: "20px" }}
      >
        {/* Email */}
        <div className="adminviewproducts-viewlead-lead-detail-item">
          <FiMail className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
          <span>{leadInfo.email || "N/A"}</span>
        </div>

        {/* Phone */}
        <div className="adminviewproducts-viewlead-lead-detail-item">
          <FiPhone className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
          <span>{leadInfo.contact_number || "N/A"}</span>
        </div>

      </div>
    </div>
  </div>
</div>

          {/* Products Section - MIDDLE */}
          <div className="adminviewproducts-viewlead-mb-4">
            <div className="adminviewproducts-viewlead-card adminviewproducts-viewlead-shadow-sm adminviewproducts-viewlead-border-0">
              <div className="adminviewproducts-viewlead-card-header adminviewproducts-viewlead-bg-white adminviewproducts-viewlead-py-3">
                <div className="adminviewproducts-viewlead-header-content">
                  <h5 className="adminviewproducts-viewlead-mb-0 adminviewproducts-viewlead-header-title" style={{paddingLeft:"10px"}}>
                    <FiShoppingCart className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-primary" />
                    Products ({products.length})
                  </h5>
                  <div className="adminviewproducts-viewlead-button-group" style={{paddingRight:"10px"}}>
                    <button
                      className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-primary adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center"
                      onClick={OpenAddModal}
                      disabled={loading}
                    >
                      <FiPlus className="adminviewproducts-viewlead-me-1" /> Add Product
                    </button>
                
                  </div>
                </div>
              </div>
              <div className="adminviewproducts-viewlead-card-body">
                {loading ? (
                  <div className="adminviewproducts-viewlead-text-center adminviewproducts-viewlead-py-5">
                    <div className="adminviewproducts-viewlead-spinner-border adminviewproducts-viewlead-text-primary" role="status">
                      <span className="adminviewproducts-viewlead-visually-hidden">Loading...</span>
                    </div>
                    <p className="adminviewproducts-viewlead-mt-2 adminviewproducts-viewlead-text-muted">Loading products...</p>
                  </div>
                ) : products.length === 0 ? (
                  <div className="adminviewproducts-viewlead-text-center adminviewproducts-viewlead-py-5">
                    <FiShoppingCart size={48} className="adminviewproducts-viewlead-text-muted adminviewproducts-viewlead-mb-3" />
                    <h5>No products added yet</h5>
                    <p className="adminviewproducts-viewlead-text-muted">Add products to create a quotation</p>
                    <button className="adminviewproducts-viewlead-btn adminviewproducts-viewlead-btn-primary adminviewproducts-viewlead-mt-2" onClick={OpenAddModal}>
                      <FiPlus className="adminviewproducts-viewlead-me-1" /> Add First Product
                    </button>
                  </div>
                ) : (
                  <ReusableTable
                    title=""
                    data={products}
                    columns={columns}
                    initialEntriesPerPage={5}
                    searchPlaceholder="Search products..."
                    striped={true}
                    hover={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Add Product Modal */}
        <AddProduct
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleSave={handleSaveProduct}
        />
      </div>
    </div>
  );
};

export default ViewLead;